import React from 'react';
import InfoTabs from './components/infoTabs';

const InformationTab = () => <InfoTabs menuCode="information"/>;

export default InformationTab;
